/**
 * 地図検索ページの DOM 参照一式
 * @typedef {Object} MapPageElements
 * @property {HTMLElement|null} root - 地図本体を描画するコンテナ
 * @property {HTMLElement|null} propertyContainer - 物件カードの挿入先（カードマーカーの content になる）
 * @property {HTMLElement|null} loading - ローディング表示（data-hidden で表示切替）
 * @property {HTMLElement|null} count - 件数カウンター
 * @property {HTMLAnchorElement|null} searchButton - 「この条件で検索」ボタン（href に ids[] を付与する）
 * @property {NodeListOf<HTMLButtonElement>} toolButtons - 地図操作ボタン（data-type で機能を区別: current / zoom-in / zoom-out）
 * @property {HTMLInputElement|null} keywordInput - キーワード検索の入力欄（駅/住所/施設）
 * @property {HTMLButtonElement|null} keywordSubmit - キーワード検索の実行ボタン
 */

/**
 * 地図検索ページの DOM 参照をまとめて取得する
 * @returns {MapPageElements}
 */
export const queryElements = () => ({
    root: document.querySelector(".js-search-map"),
    propertyContainer: document.querySelector(
        ".js-search-map__property-container"
    ),
    loading: document.querySelector(".js-search-map__loading"),
    count: document.querySelector(".js-search-map__count"),
    searchButton: document.querySelector(".js-search-map__search-button"),
    toolButtons: document.querySelectorAll(".js-search-map__tool-button"),
    keywordInput: document.querySelector(".pg-search-map__keyword-input"),
    keywordSubmit: document.querySelector(".pg-search-map__keyword-submit"),
});
